import { Injectable } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Action, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import {
  ClearNavigationStack,
  GoBack,
  OverrideReturnUrl,
  SetDefaultReturnUrl,
} from './navigation.actions';
import { NavigationStateModel } from './navigation.state-model';

@State<NavigationStateModel>({
  name: 'navigation',
  defaults: { defaultReturnUrls: [], overrideReturnUrls: [] },
})
@Injectable()
export class NavigationState {
  @Action(SetDefaultReturnUrl)
  setDefaultReturnUrl(
    ctx: StateContext<NavigationStateModel>,
    action: SetDefaultReturnUrl
  ): void {
    const state = ctx.getState();
    ctx.setState(
      patch({ defaultReturnUrls: [...state.defaultReturnUrls, action.url] })
    );
  }

  @Action(OverrideReturnUrl)
  overrideReturnUrl(
    ctx: StateContext<NavigationStateModel>,
    action: OverrideReturnUrl
  ): void {
    const state = ctx.getState();
    ctx.setState(
      patch({ overrideReturnUrls: [...state.overrideReturnUrls, action.url] })
    );
  }

  @Action(GoBack)
  goBack(ctx: StateContext<NavigationStateModel>, action: GoBack): void {
    const state = ctx.getState();
    if (
      state.overrideReturnUrls.length === 0 &&
      state.defaultReturnUrls.length === 0
    ) {
      console.warn(
        `${NavigationState.name}::goBack No return URLs available. Navigation skipped.`
      );
      return;
    }

    const overrideUrl =
      state.overrideReturnUrls[state.overrideReturnUrls.length - 1];
    const defaultUrl =
      state.defaultReturnUrls[state.defaultReturnUrls.length - 1];
    const targetUrl = overrideUrl || defaultUrl;
    ctx.setState(
      patch({
        defaultReturnUrls: state.defaultReturnUrls.slice(0, -1),
        overrideReturnUrls: state.overrideReturnUrls.slice(0, -1),
      })
    );

    if (targetUrl) {
      ctx.dispatch(new Navigate([targetUrl], action.extraParams || {}));
    } else {
      console.warn(
        `${NavigationState.name}::goBack No valid target URL found. Navigation aborted.`
      );
    }
  }

  @Action(ClearNavigationStack)
  clearNavigationStack(ctx: StateContext<NavigationStateModel>): void {
    ctx.setState(patch({ defaultReturnUrls: [], overrideReturnUrls: [] }));
  }
}
